module.exports = __webpack_public_path__ + "1003a06bab04f0e0914a2e52ec228f68.png";